export default __webpack_public_path__ + "static/Google_Play-f4734b1f54ed83fe5cd18eaaf1295658.svg";